import { useRef, useState } from 'react';
import { uploadGalleryFiles } from '../../utils/proofingApi.js';

export default function ProofUploadDropzone({ galleryId, kind = 'proofs', label, hint, onUploaded }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState('');

  async function upload(files) {
    if (!files?.length) return;

    setStatus('');
    setProgress(1);
    try {
      const payload = await uploadGalleryFiles({
        galleryId,
        files,
        kind,
        onProgress: setProgress
      });
      setStatus(`${files.length} Datei(en) verarbeitet.`);
      setProgress(0);
      onUploaded?.(payload);
    } catch (error) {
      setStatus(error.message);
      setProgress(0);
    }
  }

  return (
    <div
      className={dragging ? 'proof-dropzone is-dragging' : 'proof-dropzone'}
      onDragOver={(event) => {
        event.preventDefault();
        setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(event) => {
        event.preventDefault();
        setDragging(false);
        upload(event.dataTransfer.files);
      }}
    >
      <input
        type="file"
        accept="image/jpeg,image/png,image/webp"
        multiple
        ref={inputRef}
        onChange={(event) => upload(event.target.files)}
      />
      <p className="mono-label">{label}</p>
      <h3>{kind === 'finals' ? 'Finale High-Res Dateien' : 'Proofing Upload'}</h3>
      <p>{hint}</p>
      <button type="button" onClick={() => inputRef.current?.click()}>
        Dateien wählen
      </button>
      {progress > 0 && (
        <div className="proof-progress">
          <span style={{ width: `${progress}%` }} />
        </div>
      )}
      {status && <small>{status}</small>}
    </div>
  );
}
